/**
 * Decode a CP437 buffer.
 * @see https://en.wikipedia.org/wiki/Code_page_437
 */
export default class CP437Decoder {
  private static readonly DECODER_TABLE = [
    '\u{0}',
    '\u{263A}',
    '\u{263B}',
    '\u{2665}',
    '\u{2666}',
    '\u{2663}',
    '\u{2660}',
    '\u{2022}',
    '\u{25D8}',
    '\u{25CB}',
    '\u{25D9}',
    '\u{2642}',
    '\u{2640}',
    '\u{266A}',
    '\u{266B}',
    '\u{263C}',
    '\u{25BA}',
    '\u{25C4}',
    '\u{2195}',
    '\u{203C}',
    '\u{B6}',
    '\u{A7}',
    '\u{25AC}',
    '\u{21A8}',
    '\u{2191}',
    '\u{2193}',
    '\u{2192}',
    '\u{2190}',
    '\u{221F}',
    '\u{2194}',
    '\u{25B2}',
    '\u{25BC}',
    ' ',
    '!',
    '"',
    '#',
    '$',
    '%',
    '&',
    "'",
    '(',
    ')',
    '*',
    '+',
    ',',
    '-',
    '.',
    '/',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    ':',
    ';',
    '<',
    '=',
    '>',
    '?',
    '@',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    '[',
    '\\',
    ']',
    '^',
    '_',
    '`',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    '{',
    '|',
    '}',
    '~',
    '\u{2302}',
    '\u{C7}',
    '\u{FC}',
    '\u{E9}',
    '\u{E2}',
    '\u{E4}',
    '\u{E0}',
    '\u{E5}',
    '\u{E7}',
    '\u{EA}',
    '\u{EB}',
    '\u{E8}',
    '\u{EF}',
    '\u{EE}',
    '\u{EC}',
    '\u{C4}',
    '\u{C5}',
    '\u{C9}',
    '\u{E6}',
    '\u{C6}',
    '\u{F4}',
    '\u{F6}',
    '\u{F2}',
    '\u{FB}',
    '\u{F9}',
    '\u{FF}',
    '\u{D6}',
    '\u{DC}',
    '\u{A2}',
    '\u{A3}',
    '\u{A5}',
    '\u{20A7}',
    '\u{192}',
    '\u{E1}',
    '\u{ED}',
    '\u{F3}',
    '\u{FA}',
    '\u{F1}',
    '\u{D1}',
    '\u{AA}',
    '\u{BA}',
    '\u{BF}',
    '\u{2310}',
    '\u{AC}',
    '\u{BD}',
    '\u{BC}',
    '\u{A1}',
    '\u{AB}',
    '\u{BB}',
    '\u{2591}',
    '\u{2592}',
    '\u{2593}',
    '\u{2502}',
    '\u{2524}',
    '\u{2561}',
    '\u{2562}',
    '\u{2556}',
    '\u{2555}',
    '\u{2563}',
    '\u{2551}',
    '\u{2557}',
    '\u{255D}',
    '\u{255C}',
    '\u{255B}',
    '\u{2510}',
    '\u{2514}',
    '\u{2534}',
    '\u{252C}',
    '\u{251C}',
    '\u{2500}',
    '\u{253C}',
    '\u{255E}',
    '\u{255F}',
    '\u{255A}',
    '\u{2554}',
    '\u{2569}',
    '\u{2566}',
    '\u{2560}',
    '\u{2550}',
    '\u{256C}',
    '\u{2567}',
    '\u{2568}',
    '\u{2564}',
    '\u{2565}',
    '\u{2559}',
    '\u{2558}',
    '\u{2552}',
    '\u{2553}',
    '\u{256B}',
    '\u{256A}',
    '\u{2518}',
    '\u{250C}',
    '\u{2588}',
    '\u{2584}',
    '\u{258C}',
    '\u{2590}',
    '\u{2580}',
    '\u{3B1}',
    '\u{DF}',
    '\u{393}',
    '\u{3C0}',
    '\u{3A3}',
    '\u{3C3}',
    '\u{B5}',
    '\u{3C4}',
    '\u{3A6}',
    '\u{398}',
    '\u{3A9}',
    '\u{3B4}',
    '\u{221E}',
    '\u{3C6}',
    '\u{3B5}',
    '\u{2229}',
    '\u{2261}',
    '\u{B1}',
    '\u{2265}',
    '\u{2264}',
    '\u{2320}',
    '\u{2321}',
    '\u{F7}',
    '\u{2248}',
    '\u{B0}',
    '\u{2219}',
    '\u{B7}',
    '\u{221A}',
    '\u{207F}',
    '\u{B2}',
    '\u{25A0}',
    '\u{A0}',
  ];

  /**
   * Decode a buffer.
   */
  static decode(input: Buffer<ArrayBuffer>): string {
    return Array.from(input, (byte) => this.DECODER_TABLE[byte]).join('');
  }
}
